<template>
  <div class="chat-input">
    <div class="input-wrapper">
      <input
        :id="`ai-chat-input-${channelId}`"
        v-model="inputValue"
        type="text"
        placeholder="Ask me anything"
        :disabled="isThinking || isSending"
        @keydown.enter="handleSubmit"
      >
      <button
        class="send-button"
        :class="{ disabled: !inputValue.trim() || isSending || isThinking }"
        :disabled="!inputValue.trim() || isSending || isThinking"
        @click="handleSubmit"
      >
        <Icon
          name="lucide:send-horizontal"
        />
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useChat } from "../../../composables/useChat";
defineProps({
  isThinking: { type: Boolean, required: false }
});
const emit = defineEmits(["messageSent"]);
const inputValue = ref("");
const { sendMessage, isSending, channelId } = useChat();
async function handleSubmit() {
  if (!inputValue.value.trim()) return;
  const message = inputValue.value.trim();
  try {
    await sendMessage(message);
    emit("messageSent", message);
  } catch (error) {
    console.error("Failed to send message:", error);
    emit("messageSent", message);
  }
  inputValue.value = "";
}
function setInputValue(value) {
  inputValue.value = value;
}
defineExpose({
  setInputValue,
  handleSubmit
});
</script>

<style scoped>
.chat-input{flex-shrink:0;padding:8px 0 0}.chat-input,.input-wrapper{align-items:center;display:flex}.input-wrapper{background:#fff;border:1px solid #e9ecef;border-radius:4px;box-shadow:0 1px 3px rgba(0,0,0,.05);padding:4px;transition:all .2s ease;width:100%}.input-wrapper:focus-within{border-color:#6366f1}input{background:transparent;border:none;color:#212529;flex:1;font-size:14px;outline:none;padding:10px 16px}input::-moz-placeholder{color:#adb5bd}input::placeholder{color:#adb5bd}.send-button{align-items:center;background-color:#6366f1;border:none;border-radius:50%;cursor:pointer;display:flex;flex-shrink:0;height:36px;justify-content:center;margin-left:8px;transition:all .2s ease;width:36px}.send-button .iconify{background-color:#fff}.send-button:hover:not(:disabled),.send-button:not(:disabled):active{transform:scale(.95)}.send-button:disabled{background:#e1e1e1;color:#757575;cursor:not-allowed;opacity:.4}.send-button:disabled .iconify{background-color:#757575}
</style>
